import { useRuntime } from '../internal';
import type { LoadedXinglet } from '../xinglet';

export function useSuspenseXinglet(name: string): LoadedXinglet {
  const runtime = useRuntime();
  const eventual = runtime.loadXinglet(name);

  if (!eventual.settled) {
    throw Promise.resolve(eventual);
  } else if (eventual.error) {
    throw eventual.error;
  } else {
    // oxlint-disable-next-line typescript/no-non-null-assertion
    return eventual.value!;
  }
}
